import { Alert } from 'bootstrap/dist/js/bootstrap.esm.min'

Array.from( document.querySelectorAll( '.wp-toolkit .alert' ) )
     .forEach( alertNode => new Alert( alertNode ) )
